var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{ref:"list",attrs:{"row-key":"ScheduleId","unit":"用户","expand-all-row":true,"page":_vm.page,"show-checkbox":true,"show-query":false,"query-params":_vm.params,"get-data-func":_vm.api.list}},[_c('template',{slot:"toolbar-right"},[_vm._t("toolbar-right")],2),_c('template',{slot:"table"},[_vm._t("column")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }